import type { RouteRecordRaw } from "vue-router"
const Calendar = () => import("./views/Calendar.vue")

const routes: RouteRecordRaw[] = [
  {
    path: "/calendar",
    component: Calendar,
    name: "calendar:home",
  },
]

export default routes
